// src/polyfills.js
(function() {
  if (typeof window !== 'undefined' && typeof global === 'undefined') {
    window.global = window; // Shim global to window in browser environments
  }
  // Optional: Shim setImmediate if needed (fbjs uses it in some cases)
  if (!window.setImmediate) {
    window.setImmediate = function(fn) {
      return setTimeout(fn, 0);
    };
  }
})();
